import { useState } from 'react';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    mensaje: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d6pjqmtsbgrc47filofg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ nombre: '', email: '', telefono: '', mensaje: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contacto" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-block px-6 py-2 bg-[#FAF8F5] rounded-full mb-6">
              <span className="text-gray-700 text-sm font-light">Contacto</span>
            </div>
            <h2 className="font-['Playfair_Display'] text-5xl lg:text-6xl font-bold text-gray-900 mb-8 leading-tight">
              ¿Tenés Alguna Consulta?
            </h2>
            <p className="text-gray-600 text-lg font-light leading-relaxed mb-12">
              Escribinos y te ayudamos a encontrar el producto ideal para tu tipo de piel o a coordinar tu pedido en Costa Rica.
            </p>

            <div className="space-y-8">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#D4AF37]/10 rounded-full flex-shrink-0">
                  <i className="ri-map-pin-line text-[#D4AF37] text-xl"></i>
                </div>
                <div>
                  <h4 className="text-gray-900 font-semibold text-base mb-1">Ubicación</h4>
                  <p className="text-gray-600 text-sm font-light">Costa Rica — Distribución a todo el país</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#D4AF37]/10 rounded-full flex-shrink-0">
                  <i className="ri-whatsapp-line text-[#D4AF37] text-xl"></i>
                </div>
                <div>
                  <h4 className="text-gray-900 font-semibold text-base mb-1">WhatsApp</h4>
                  <p className="text-gray-600 text-sm font-light">+506 6102-5212</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#D4AF37]/10 rounded-full flex-shrink-0">
                  <i className="ri-mail-line text-[#D4AF37] text-xl"></i>
                </div>
                <div>
                  <h4 className="text-gray-900 font-semibold text-base mb-1">Email</h4>
                  <p className="text-gray-600 text-sm font-light">beautydealscr@gmail.com</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#D4AF37]/10 rounded-full flex-shrink-0">
                  <i className="ri-instagram-line text-[#D4AF37] text-xl"></i>
                </div>
                <div>
                  <h4 className="text-gray-900 font-semibold text-base mb-1">Instagram</h4>
                  <a
                    href="https://www.instagram.com/beautydeals_cr?igsh=MWhzajEwYzYzMTN5eQ=="
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="text-gray-600 text-sm font-light hover:text-[#D4AF37] transition-colors cursor-pointer"
                  >
                    @beautydeals_cr
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-[#FAF8F5] p-10 rounded-3xl">
            <h3 className="font-['Playfair_Display'] text-2xl font-bold text-gray-900 mb-2">Envianos un Mensaje</h3>
            <p className="text-gray-500 text-sm font-light mb-6">Completá el formulario y te respondemos a tu correo o WhatsApp.</p>
            <form id="contact-form" onSubmit={handleSubmit} data-readdy-form>
              <div className="space-y-5">
                <div>
                  <label htmlFor="nombre" className="block text-gray-900 text-sm font-medium mb-2">Nombre completo</label>
                  <input
                    type="text" id="nombre" name="nombre"
                    value={formData.nombre} onChange={handleChange} required
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-sm text-gray-900 focus:outline-none focus:border-[#D4AF37] transition-colors"
                    placeholder="Tu nombre"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-gray-900 text-sm font-medium mb-2">Email</label>
                  <input
                    type="email" id="email" name="email"
                    value={formData.email} onChange={handleChange} required
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-sm text-gray-900 focus:outline-none focus:border-[#D4AF37] transition-colors"
                    placeholder="tu@email.com"
                  />
                </div>
                <div>
                  <label htmlFor="telefono" className="block text-gray-900 text-sm font-medium mb-2">Teléfono / WhatsApp</label>
                  <input
                    type="tel" id="telefono" name="telefono"
                    value={formData.telefono} onChange={handleChange} required
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-sm text-gray-900 focus:outline-none focus:border-[#D4AF37] transition-colors"
                    placeholder="+506 0000-0000"
                  />
                </div>
                <div>
                  <label htmlFor="mensaje" className="block text-gray-900 text-sm font-medium mb-2">Mensaje</label>
                  <textarea
                    id="mensaje" name="mensaje"
                    value={formData.mensaje} onChange={handleChange} required
                    maxLength={500} rows={4}
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-sm text-gray-900 focus:outline-none focus:border-[#D4AF37] transition-colors resize-none"
                    placeholder="¿En qué te podemos ayudar?"
                  ></textarea>
                  <p className="text-xs text-gray-500 mt-1">{formData.mensaje.length}/500 caracteres</p>
                </div>
                <button
                  type="submit" disabled={isSubmitting}
                  className="w-full px-8 py-4 bg-gray-900 text-white text-base font-medium rounded-full hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                >
                  {isSubmitting ? 'Enviando...' : 'Enviar Mensaje'}
                </button>
                {submitStatus === 'success' && (
                  <p className="text-green-600 text-sm text-center">¡Mensaje enviado! Te contactamos pronto.</p>
                )}
                {submitStatus === 'error' && (
                  <p className="text-red-600 text-sm text-center">Error al enviar. Por favor intentá de nuevo.</p>
                )}

                <div className="flex items-center gap-3 my-2">
                  <div className="flex-1 h-px bg-gray-200"></div>
                  <span className="text-gray-400 text-xs font-light">o escribinos directo</span>
                  <div className="flex-1 h-px bg-gray-200"></div>
                </div>

                <a
                  href="https://wa.me/50661025212?text=Hola%2C%20tengo%20una%20consulta%20sobre%20sus%20productos%20de%20skincare%20importado."
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-full flex items-center justify-center gap-3 px-8 py-4 bg-[#25D366] text-white text-base font-medium rounded-full hover:bg-[#1ebe5d] transition-colors whitespace-nowrap cursor-pointer"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-whatsapp-line text-white text-xl"></i>
                  </div>
                  Escribir por WhatsApp
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
